/*
 * Copyright 2017 Google Inc. All rights reserved.
 *
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

// Style credit: https://snazzymaps.com/style/1/pale-dawn
const mapStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#EBEBE5"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#EBEBE5"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#cac0b6"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#EBEBE5"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#DCDCD3"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#DCDCD3"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];

/*
https://stackoverflow.com/questions/37751613/set-google-map-marker-points-from-dom-elements-array
*/

var map;
var markers = []; // Create a marker array to hold markers
  

// Escapes HTML characters in a template literal string, to prevent XSS.
// See https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet#RULE_.231_-_HTML_Escape_Before_Inserting_Untrusted_Data_into_HTML_Element_Content
function sanitizeHTML(strings) {
  const entities = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
  let result = strings[0];
  for (let i = 1; i < arguments.length; i++) {
    result += String(arguments[i]).replace(/[&<>'"]/g, (char) => {
      return entities[char];
    });
    result += strings[i];
  }
  return result;
}


// ** This is the function that I'm using to create a two-dimensional array based on my listed DOM items. The console log shows the array correctly, but I have no idea how to pass this array as a variable into the Google Map ** 
function makeMapPlotPoints() {

  // Set marker from results list and create empty plot point array
  var mapPlotPointDOM = $(".stockist");
  var mapPlotPointArr = [];

  $(mapPlotPointDOM).each(function() {
    mapPlotPointArr.push([
      $(this).data("store-name"),
      $(this).data("latitude"),
      $(this).data("longitude"),
      $(this).data("marker-id"),
    ]);
  });
  console.log(mapPlotPointArr);
  setMarkers(mapPlotPointArr);
}


function setMarkers(locations) {

  for (var i = 0; i < locations.length; i++) {
    var mapMarkerItem = locations[i];
    var myLatLng = new google.maps.LatLng(mapMarkerItem[1], mapMarkerItem[2]);
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      animation: google.maps.Animation.DROP,
      title: mapMarkerItem[0],
      zIndex: mapMarkerItem[3],
      icon: {
          url: 'https://cdn.shopify.com/s/files/1/0779/2397/5449/files/Ico-MapPointer.png?v=1725940191',
          scaledSize: new google.maps.Size(40, 51)
        }
    });

    // Push marker to markers array
    markers.push(marker);

    var infowindow = new google.maps.InfoWindow();
    
    // Marker Info Window?tooltip
   google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        
        var markerHTML = $('.stockist-group').find("[data-marker-id='" + locations[i][3] + "']").html();
        infowindow.setContent(markerHTML);
        infowindow.open(map, marker);
      }
    })(marker, i));
   
  }
}
    
function reloadMarkers() {

  // Loop through markers and set map to null for each
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }

  // Reset the markers array
  markers = [];
  // Call set markers to re-add markers
  makeMapPlotPoints();
}


function initMap() {
  // Create the map.
  map = new google.maps.Map(document.getElementsByClassName('map')[0], {
     mapTypeControl: false,
     zoom: 6,
    //center: {lat:-36.867803, lng:174.777157},
    center: {lat:51.517686, lng:-0.2034105},
    styles: mapStyle
  });
  
  // Load the stores GeoJSON onto the map.
  makeMapPlotPoints();
  
  const apiKey = 'AIzaSyC_fhxNc7e6KIgDsYTC370p6nOV7vJYxCg';
  
  $(document).on('click', '.map-link', function() {
  const stockistDiv = $(this).closest('.stockist');
  const lat = parseFloat(stockistDiv.data('latitude'));
  const lng = parseFloat(stockistDiv.data('longitude'));

  if (!isNaN(lat) && !isNaN(lng)) {
    const position = new google.maps.LatLng(lat, lng);
    map.setCenter(position);
    map.setZoom(14); // Adjust zoom level as needed

    // Optionally: trigger marker click to show info window
    const markerId = stockistDiv.data('marker-id');
    const marker = markers.find(m => m.zIndex == markerId);
    if (marker) {
      google.maps.event.trigger(marker, 'click');
    }
  }
});

}

function initCustomMaps() {
  const customMapEls = document.querySelectorAll('.custom-map');
  if (!customMapEls.length) return;

  customMapEls.forEach(el => {
    const lat = parseFloat(el.dataset.latitude);
    const lng = parseFloat(el.dataset.longitude);

    if (!isNaN(lat) && !isNaN(lng)) {
      const customMap = new google.maps.Map(el, {
        center: { lat, lng },
        zoom: 13,
        styles: mapStyle,
        mapTypeControl: false,
        streetViewControl: false
      });

      new google.maps.Marker({
        position: { lat, lng },
        map: customMap,
        icon: {
          url: 'https://cdn.shopify.com/s/files/1/0779/2397/5449/files/Ico-MapPointer.png?v=1725940191',
          scaledSize: new google.maps.Size(40, 51)
        }
      });
    }
  });
}

